export default __webpack_public_path__ + "static/media/game_calendar.48f9d158.svg";